export var CustomerPermissions;
(function (CustomerPermissions) {
    CustomerPermissions["COMPANY_MANAGE_OWN"] = "Company.ManageOwn";
    CustomerPermissions["USERS_LIST"] = "Users.List";
    CustomerPermissions["USERS_ENABLE"] = "Users.Enable";
    CustomerPermissions["USERS_DISABLE"] = "Users.Disable";
    CustomerPermissions["USERS_REGISTER"] = "User.Register";
    CustomerPermissions["USERS_CHANGE_ROLE"] = "Users.Role.Change";
    CustomerPermissions["USERS_CHANGE_OWNER"] = "Users.Owner.Change";
    CustomerPermissions["USERS_REMOVE_FROM_DEPARTMENT"] = "Users.RemoveFromDepartment";
    CustomerPermissions["FEATURES_TIERS_READ"] = "Features.Read";
    CustomerPermissions["FEATURES_TIERS_MANAGE"] = "Features.Manage";
    CustomerPermissions["NOTIFICATIONS_COMPANY_SUBREAD"] = "Notifications.Company.ReadSubscriptions";
    CustomerPermissions["NOTIFICATIONS_COMPANY_SUBEDIT"] = "Notifications.Company.EditSubscriptions";
    CustomerPermissions["NOTIFICATIONS_COMPANY_PRESET_EDIT"] = "Notifications.Company.Presets.Edit";
    CustomerPermissions["VALIDATION_CREATE"] = "Validation.Create";
    CustomerPermissions["VALIDATION_COMPANY_CREATE"] = "Validation.Company.Create";
    CustomerPermissions["ISSUES_READ"] = "Issues.Read";
    CustomerPermissions["EVENTS_READ"] = "Events.Read";
    CustomerPermissions["SOURCES_READ"] = "Source.Read";
    CustomerPermissions["SOURCES_MANAGE"] = "Source.Manage";
    CustomerPermissions["SOURCES_MANAGE_SERVICE"] = "Source.Service.Manage";
    CustomerPermissions["SOURCEGROUPS_READ"] = "SourceGroup.Read";
    CustomerPermissions["SOURCEGROUPS_MANAGE"] = "SourceGroup.Manage";
    CustomerPermissions["SOURCEGROUPS_MANAGESOURCES"] = "SourceGroup.ManageSources";
    CustomerPermissions["DASHBOARD_MANAGE"] = "Dashboard.Manage";
    CustomerPermissions["SOURCES_FLOOR_PLAN_EDIT"] = "Sources.Floor.Plan.Edit";
    CustomerPermissions["SOURCES_FLOOR_PLAN_READ"] = "Sources.Floor.Plan.Read";
    CustomerPermissions["LOGGERS_MANAGE"] = "Loggers.Manage";
    CustomerPermissions["LOGGERS_READ"] = "Loggers.Read";
    CustomerPermissions["LOGGERS_READ_RSSI"] = "Loggers.Read.Rssi";
    CustomerPermissions["LOGGERS_ACTION_MEMORY_READ"] = "Loggers.Action.MemoryRead";
    CustomerPermissions["DEVICE_MANAGE"] = "Device.Manage";
    CustomerPermissions["DEVICE_READ"] = "Device.Read";
    CustomerPermissions["DEVICE_REGISTER"] = "Device.Register";
    CustomerPermissions["DEVICEGROUP_READ"] = "DeviceGroup.Read";
    CustomerPermissions["DEVICEGROUP_MANAGE"] = "DeviceGroup.Manage";
    CustomerPermissions["DEVICEGROUP_MANAGEDEVICES"] = "DeviceGroup.ManageDevice";
    CustomerPermissions["REPORTS_READ"] = "Reports.Read";
    CustomerPermissions["REPORTS_MANAGE"] = "Reports.Configure";
    CustomerPermissions["REPORTS_ANNOTATE"] = "Reports.Annotate";
    CustomerPermissions["REPORTS_EXPORTPDF"] = "Reports.ExportPdf";
    CustomerPermissions["REPORTS_CONFIGURATION_READ"] = "Reports.Configuration.Read";
    CustomerPermissions["REPORTS_CONFIGURATION_MANAGE"] = "Reports.Configuration.Manage";
})(CustomerPermissions || (CustomerPermissions = {}));
